import emptyComponent from './empty.component';

const emptyModule = angular
  .module('emptyModule', [])
  .component('empty', emptyComponent);

export default emptyModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/utility/empty/empty.js
 **/